<template>
  <v-icon v-if="action.icon" small :color="action.color">
    mdi-{{ action.icon }}
  </v-icon>
</template>

<script lang="ts">
import Vue from "vue";
import VueTypes from "vue-types";

export default Vue.extend({
  name: "ActionsIcon",
  data() {
    return {};
  },
  props: {
    action: VueTypes.any.def({}),
  },
});
</script>
